import appData from '@/helpers/app-data'
import axios from 'axios'
import airbrake from '@/helpers/airbrake'

const state = {
  providerInfo: appData.get('provider_info') || {},
  loading: false,
  updated: false,
  errors: null
}

const mutations = {
  UPDATED (state) {
    state.updated = true
  },
  SET_LOADING (state, value) {
    state.loading = value
  },
  SET_ERRORS (state, errors) {
    state.errors = errors
  }
}

function handleErrors (commit, error) {
  airbrake.notify(error)
  const response = error.response || {}
  let data = response.data || {}
  let errors
  commit('SET_LOADING', false)
  if (data.no_change) {
    errors = { generic: 'Failed to update the profile because no changes were made to it. Update some fields below and try again.' }
  } else if (data.errors) {
    errors = data.errors
  } else if (response.status === 401) {
    errors = { generic: 'Please log in and try again.' }
  } else {
    errors = { generic: 'Failed to submit the provider profile. Please try again' }
  }
  commit('SET_ERRORS', errors)
}

const actions = {
  save ({commit}, providerData) {
    if (!state.loading) {
      commit('SET_LOADING', true)

      if (providerData.provider_id) { // update
        return axios.put(`/provider_info/${providerData.provider_id}`, { provider_info: providerData })
          .then(response => {
            commit('SET_LOADING', false)
            commit('SET_ERRORS', null)
            commit('UPDATED')
          })
          .catch(error => {
            handleErrors(commit, error)
          })
      } else { // create
        return axios.post('/provider_info', { provider_info: providerData })
          .then(response => {
            commit('SET_LOADING', false)
            commit('SET_ERRORS', null)
            commit('UPDATED')
          })
          .catch(error => {
            handleErrors(commit, error)
          })
      }
    }
  },
  addErrors ({commit}, errors) {
    commit('SET_ERRORS', errors)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./frontend/src/store/modules/providerInfo/index.js